import { Component, effect, Input, model } from '@angular/core';
import { IItemsTableOptions } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source-items/interfaces/items-table-options.interface';
import { FiltersChannel } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/models/filters-channel.model';
import { TableComponent } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/components/table/table.component';
import { IFilters } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filters.interface';
import { ITablePagination } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-pagination.interface';
import { ITableSort } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-sort.interface';
import { ITableDataSource } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table-data-source.interface';
import { SessionService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/services/session.service';
import { ICpr } from '../../interface/cpr.interface';
import { CprsService } from '../../service/cprs.service';

@Component({
  selector: 'app-cprs-table',
  templateUrl: './cpr-table.component.html',
  styles: `
    table {
      width: 100%;
    }

    .hidden {
      display: none;
    }
  `,
})
export class CprTableComponent extends TableComponent<ICpr, string> {
  readonly headings = ['oldCprId', 'label', 'inUse', 'comment', 'updatedAt'];

  @Input() filtersChannel?: FiltersChannel;
  @Input() options: IItemsTableOptions;
  @Input() dontCache = false;
  @Input() tableAlias: string;

  pageSize = this.options?.defaultPageSize || 15;
  canSort = false;

  showInUseCprsOnly = model(true);

  private readonly refreshEffect = effect(() => {
    console.log('refresh');
    if (typeof this.showInUseCprsOnly() === 'boolean') {
      this.refresh();
    }
  });

  constructor(
    sessionService: SessionService,
    private readonly cprsService: CprsService,
  ) {
    super(sessionService);
  }

  ngOnDestroy() {
    this.refreshEffect.destroy();
    super.ngOnDestroy();
  }

  protected getPaginated(
    filters: IFilters,
    sort: ITableSort,
    pagination: ITablePagination,
    search: string,
  ): Promise<ITableDataSource<ICpr>> {
    return this.cprsService.getPaginated('', {
      filters,
      sort,
      pagination,
      search,
      simpleFilters: this.showInUseCprsOnly() ? { inUse: true } : undefined,
    });
  }
}
